import React from 'react';
import { LoadingRing } from '../../ui';

// The shared ring, sized by `.spinner-img` as the gif it replaced was (1em in a page title).
const Spinner = () => {
  return <LoadingRing className="spinner-img" />;
};

export default Spinner;
